import { render } from "./ProjectBatchTools.vue?vue&type=template&id=de44808e&scoped=true"
import script from "./ProjectBatchTools.vue?vue&type=script&lang=js"
export * from "./ProjectBatchTools.vue?vue&type=script&lang=js"

import "./ProjectBatchTools.vue?vue&type=style&index=0&id=de44808e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de44808e"]])

export default __exports__